import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IChungChiChungNhanSinhVien } from "../../../model/response/chung-chi-chung-nhan/IChungChiChungNhanSinhVien";
import { IChungChiChungNhanSinhVienViewModel } from "../../../model/response/chung-chi-chung-nhan/IChungChiChungNhanSinhVienViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eChungChiChungNhanSinhVienActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IChungChiChungNhanSinhVienViewModel[],
    LOAD_ERROR: "",

    LOAD_BY_CHUNG_CHI_CHUNG_NHAN_START: 0,
    LOAD_BY_CHUNG_CHI_CHUNG_NHAN_SUCCESS: {} as IChungChiChungNhanSinhVienViewModel[],
    LOAD_BY_CHUNG_CHI_CHUNG_NHAN_ERROR: "",

    SAVE_START: undefined,
    SAVE_SUCCESS: {} as IChungChiChungNhanSinhVien,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    DELETES_START: {} as IIdsRequest,
    DELETES_SUCCESS: undefined,
    DELETES_ERROR: "",

    UPLOAD_MODAL_OPEN: 0,
    UPLOAD_MODAL_CLOSE: undefined,
}

export const eChungChiChungNhanSinhVienActionIds = generateActionTypeIds(eChungChiChungNhanSinhVienActionsObj, "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN");
export type IChungChiChungNhanSinhVienActionTypes = IGenericActionType<typeof eChungChiChungNhanSinhVienActionsObj, "CHUNG_CHI_CHUNG_NHAN_SINH_VIEN">;
